export const FAQS_PAGE = {
  title: "FAQs",
  lastUpdated: "April 23, 2026",
  lead: "Helpful answers to common questions about delivery, authenticity, payments, and returns.",
  sections: [
    {
      heading: "Ordering",
      points: [
        "Orders are confirmed after successful Paystack payment.",
        "You will receive an order confirmation once your payment has been verified.",
        "If you need help before placing an order, contact us and we will guide you."
      ]
    },
    {
      heading: "Authenticity",
      points: [
        "All fragrances sold by Tiwani are represented as authentic products.",
        "We focus on clean presentation, careful handling, and customer confidence.",
        "If something about your order seems wrong, contact support promptly."
      ]
    },
    {
      heading: "Delivery",
      points: [
        "Oyo deliveries typically arrive within 1 to 2 days.",
        "Nationwide deliveries typically arrive within 3 to 5 days.",
        "Delivery timing can vary during holidays, weekends, or high-volume periods."
      ]
    }
  ]
};

export const ORDER_TRACKING_PAGE = {
  title: "Order Tracking",
  lastUpdated: "April 23, 2026",
  lead: "We currently support order-tracking updates through direct customer support.",
  sections: [
    {
      heading: "How To Track",
      points: [
        "Keep your order reference after checkout.",
        "Send your order reference to our support email or phone line.",
        "We will confirm your order status and delivery progress."
      ]
    },
    {
      heading: "Helpful Details To Share",
      points: [
        "Full name used at checkout.",
        "Email address used for the order.",
        "Order reference from your receipt or confirmation page."
      ]
    }
  ]
};

export const SHIPPING_POLICY_PAGE = {
  title: "Shipping Policy",
  lastUpdated: "April 23, 2026",
  lead: "This policy explains how delivery timelines, coverage, and fulfillment are handled for Tiwani orders.",
  sections: [
    {
      heading: "Delivery Timelines",
      points: [
        "Orders to Oyo usually arrive within 1 to 2 business days.",
        "Orders outside Oyo usually arrive within 3 to 5 business days.",
        "Delivery times are estimates and may shift due to operational or courier delays."
      ]
    },
    {
      heading: "Coverage",
      points: [
        "Delivery fees depend on the state and city selected at checkout.",
        "Available delivery locations are shown before payment is completed.",
        "If a location is temporarily unavailable, checkout may be restricted until a covered location is selected."
      ]
    },
    {
      heading: "Order Processing",
      points: [
        "Orders are processed after payment verification.",
        "Incorrect delivery details may delay dispatch.",
        "Customers should provide accurate phone numbers and addresses to avoid failed delivery attempts."
      ]
    }
  ]
};

export const REFUND_POLICY_PAGE = {
  title: "Refund Policy",
  lastUpdated: "April 23, 2026",
  lead: "This policy outlines when refund requests may be reviewed and how support should be contacted.",
  sections: [
    {
      heading: "Eligibility",
      points: [
        "Refund requests should be raised as soon as an issue is discovered.",
        "Requests may be reviewed for incorrect items, damaged delivery, or failed fulfillment.",
        "Support may request order details, photos, or payment references before resolving the issue."
      ]
    },
    {
      heading: "Non-Returnable Cases",
      points: [
        "Used products may not qualify for return or refund review.",
        "Requests made long after confirmed delivery may be declined.",
        "Minor packaging wear from standard shipping may not qualify as damage."
      ]
    },
    {
      heading: "How Refunds Are Handled",
      points: [
        "Approved refunds are processed back through the available payment path.",
        "Refund timing can depend on payment-provider processing windows.",
        "We recommend contacting support before disputing a charge so we can resolve it directly."
      ]
    }
  ]
};

export const TERMS_PAGE = {
  title: "Terms & Conditions",
  lastUpdated: "April 23, 2026",
  lead: "These terms govern use of the Tiwani website and related checkout services.",
  sections: [
    {
      heading: "Website Use",
      points: [
        "Customers should provide accurate information during checkout and support requests.",
        "Abusive, fraudulent, or harmful use of the site is not permitted.",
        "We may update product availability, pricing, or site content without prior notice."
      ]
    },
    {
      heading: "Orders And Payments",
      points: [
        "Orders are subject to payment verification and acceptance.",
        "Completion of payment does not guarantee fulfillment if a product becomes unavailable or a verification issue occurs.",
        "Displayed totals, taxes, and delivery fees are shown before payment is completed."
      ]
    },
    {
      heading: "Liability",
      points: [
        "We aim to keep all information accurate, but occasional errors may occur.",
        "We are not responsible for delays caused by third-party courier or payment disruptions.",
        "Support should be contacted promptly if you notice a problem with your order."
      ]
    }
  ]
};

export const PRIVACY_PAGE = {
  title: "Privacy Policy",
  lastUpdated: "April 23, 2026",
  lead: "This policy explains what information may be collected during browsing, checkout, and support interactions.",
  sections: [
    {
      heading: "Information We Use",
      points: [
        "Name, email, phone number, and delivery address may be used for order processing.",
        "Order references and product details may be used for customer support and fulfillment.",
        "Technical or usage data may be collected through the tools required to run the site."
      ]
    },
    {
      heading: "Why We Use It",
      points: [
        "To process orders and provide delivery updates.",
        "To respond to contact requests and customer support needs.",
        "To improve store operations, reliability, and service quality."
      ]
    },
    {
      heading: "Data Care",
      points: [
        "Payment details are handled through secure payment providers and are not stored as raw card data by the site.",
        "We aim to limit access to customer information to what is necessary for operations.",
        "If you have a privacy concern, contact support and we will review the request."
      ]
    }
  ]
};
